module.exports = __webpack_public_path__ + "media/images/bottles/bottle-blanc-402e4587b081a6c52184afd1892b6104.png";